import { render, staticRenderFns } from "./SettlementDetail.vue?vue&type=template&id=1ecf1de0&scoped=true"
import script from "./SettlementDetail.vue?vue&type=script&lang=js"
export * from "./SettlementDetail.vue?vue&type=script&lang=js"
import style0 from "./SettlementDetail.vue?vue&type=style&index=0&id=1ecf1de0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ecf1de0",
  null
  
)

export default component.exports